import React from 'react';

export default function StarRating({ value = 0, onChange }) {
  return (
    <div className="flex items-center gap-1 mb-2">
      {[1, 2, 3, 4, 5].map(star => (
        <button
          key={star}
          type="button"
          onClick={() => onChange && onChange(star)}
          className={star <= value ? 'text-accent2' : 'text-grey'}
          style={{ fontSize: 28, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          aria-label={`Geef ${star} sterren`}
        >
          ★
        </button>
      ))}
    </div>
  );
} 